module.exports = __webpack_public_path__ + "img/export-btn-excel.dbe786c6.svg";